export default{

    welcomeBonus(state){
        return state.welcomeBonus
    },

    referralBonus(state){
        return state.referralBonus
    },

    equilibrumBonus(state){
        return state.equilibrumBonus
    },

    loyaltyBonus(state){
        return state.loyaltyBonus
    },

    profitPool(state){
        return state.profitPool
    },

    profitPools(state){
        return state.profitPools
    },

    globalProfit(state){
        return state.globalProfit
    },

    globalProfits(state){
        return state.globalProfits
    },

    placementBonus(state){
        return state.placementBonus
    },

    totalBonus(state){
        return state.totalBonus
    },

    walletBalance(state){
        return state.walletBalance
    },

    totalEquilibrumBonus(state){
        return state.totalEquilibrumBonus
    },

    totalLoyaltyBonus(state){
        return state.totalLoyaltyBonus
    },

    totalProfitPoolBonus(state){
        return state.totalProfitPoolBonus
    },

    totalGlobalProfitBonus(state){
        return state.totalGlobalProfitBonus
    },


    countEquilibrumBonus(state){
        return state.countEquilibrumBonus
    },

    countLoyaltyBonus(state){
        return state.countLoyaltyBonus
    },

    countProfitPoolBonus(state){
        return state.countProfitPoolBonus
    },

    countGlobalProfitBonus(state){
        return state.countGlobalProfitBonus
    },

    companyWalletBalance(state){
        return state.companyWalletBalance
    },

    totalCompanyWallet(state){
        return state.totalCompanyWallet
    }
}